export const RECAPTCHA_ERROR_TITLE = 'Verificação de segurança';

export const RECAPTCHA_ERROR_MESSAGE = 'Não conseguimos confirmar a segurança da sua conexão.'
  + ' Verifique sua internet e tente novamente.';

export class RecaptchaError extends Error {
  constructor() {
    super(RECAPTCHA_ERROR_MESSAGE);
    this.name = 'RecaptchaError';

    Object.setPrototypeOf(this, RecaptchaError.prototype);
  }
}

export type GetRecaptchaToken = () => Promise<string | null | undefined>;

type ErrorResponse = { response?: { data?: { code?: string }; status?: number } };

const getErrorCode = (error: unknown) => (error as ErrorResponse)?.response?.data?.code
  ?? (error as { data?: ErrorResponse })?.data?.response?.data?.code;

export const isRecaptchaBlocked = (error: unknown) => getErrorCode(error) === 'RECAPTCHA_BLOCKED';

export const isRecaptchaError = (error: unknown) => error instanceof RecaptchaError
  || isRecaptchaBlocked(error);

const safeGetToken = async (getToken: GetRecaptchaToken) => {
  try {
    return await getToken();
  } catch {
    return null;
  }
};

export async function withRecaptcha<T>(
  getToken: GetRecaptchaToken,
  request: (reCaptcha: string) => Promise<T>,
): Promise<T> {
  const reCaptcha = await safeGetToken(getToken);
  if (!reCaptcha) throw new RecaptchaError();

  try {
    return await request(reCaptcha);
  } catch (error) {
    if (!isRecaptchaBlocked(error)) throw error;

    const freshReCaptcha = await safeGetToken(getToken);
    if (!freshReCaptcha) throw error;

    return request(freshReCaptcha);
  }
}
